export function removeEmptyParams(json: any): any {
  if (!json) return {};
  const result: any = {};
  for (const key in json) {
    if (json[key] !== null && json[key] !== undefined && json[key] !== '') {
      result[key] = json[key];
    }
  }
  return result;
}
